
















import { computed, defineComponent } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "MessageMediaItemStatus",
  components: { BaseSpinner },
  props: {
    attachment: { type: Object as () => FileData, required: true },
    isAuthor: { type: Boolean, required: true },
  },
  setup(props) {
    const processing = computed(() => props.attachment.processingStatus !== "OK");
    const error = computed(() => props.attachment.processingStatus === "ERROR");

    return { processing, error };
  },
});
